import { render, staticRenderFns } from "./LimitNotification.vue?vue&type=template&id=284dec7c&scoped=true&"
import script from "./LimitNotification.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LimitNotification.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LimitNotification.vue?vue&type=style&index=0&id=284dec7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284dec7c",
  null
  
)

export default component.exports